<script setup>
import { computed } from 'vue';

const props = defineProps({
  positioned: {
    default: false,
    required: false,
    type: Boolean,
  },
});
const modifiers = computed(() => {
  return {
    'c-alert-box--positioned': props.positioned,
  };
});
</script>

<template>
  <div :class="modifiers" class="c-alert-box">
    <slot />
  </div>
</template>

<style lang="scss">
@import 'sass-mq';
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/breakpoints';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/fonts';

.c-alert-box {
  margin-right: auto;
  margin-left: auto;
  padding: rem(14px);
  width: 100%;
  max-width: rem(570px);
  background-color: $color-error;
  color: $white;
  font-size: rem(14px);
  font-weight: $font-weight-bold;
  line-height: (20 / 14);
  text-align: center;

  &--positioned {
    position: absolute;
    top: rem(28px);
    right: 0;
    left: 0;
    z-index: 2;
  }
}
</style>
